import { useState } from "react";

import { Button } from "@/shared/ui/button";

import { useURLParamsData } from "@/shared/hooks/useURLParamsData";
import { localizationMap } from "@/shared/lib/consts.ts";
import { Modal } from "@/shared/ui/Modal";

interface ResetSortingButtonProps {
  resetHandler?: any;
  tableHeader: { headers: any[] }[];
}

export const SortingButton = ({ tableHeader }: ResetSortingButtonProps) => {
  const { setPage, setSort, setOrder } = useURLParamsData();
  const [sortState, setSortState] = useState("");
  const [orderState, setOrderState] = useState<"asc" | "desc" | null>(null);
  // const [statusState, setStatusState] = useState("");
  const tables = tableHeader[0].headers.filter(
    (header) => header.column.columnDef.enableSorting,
  );

  const handleSort = () => {
    if (sortState) setSort(sortState);
    if (orderState) setOrder(orderState);
    // if (statusState) setStatus(status);
  };

  const resetHandlerFunction = () => {
    setPage(1);
    setSort(null);
    setOrder(null);
  };

  if (tables.length === 0) {
    return;
  }

  return (
    <Modal>
      <Modal.Trigger asChild>
        <Button
          className="onClick h-10 max-w-sm text-textColor"
          onClick={resetHandlerFunction}
          size="default"
          variant={"outline"}
        >
          Сортировать
        </Button>
      </Modal.Trigger>
      <Modal.Content>
        <Modal.Title>Сортировать</Modal.Title>

        <div className="!m-0 mb-auto flex flex-row flex-wrap justify-around">
          {tables.map((table) => (
            <div className="mb-2 flex flex-col gap-1" key={table.id}>
              <p className="text-[12px] text-textGrayColor">
                {localizationMap[table.id]}
              </p>
              <Button
                onClick={() => {
                  if (sortState === table.id) {
                    setOrderState(orderState === "asc" ? "desc" : "asc");
                  } else {
                    setSortState(table.id);
                    setOrderState("asc");
                  }
                }}
                variant={sortState === table.id ? "default" : "outline"}
                size="lg"
                className={`h-[52px] w-[175px] ${sortState === table.id ? "text-bgColor" : "text-textColor"}`}
              >
                {sortState === table.id && orderState === "desc"
                  ? "По убыванию"
                  : "По возрастанию"}
              </Button>
            </div>
          ))}
        </div>
        <div className="!mt-32 space-y-2">
          <Button onClick={handleSort} className="w-full">
            Применить
          </Button>

          <Modal.Close>Отмена</Modal.Close>
        </div>
      </Modal.Content>
    </Modal>
  );
};
